import * as React from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { logoutStatic } from "../../../StateManagement/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SweetAlert from "../SweetAlert/SweetAlert";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { BASE_URL } from "../Api/Api";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import { InputFormat } from "../FormOptions/InputFormat";
import TelInput from "../FormOptions/TelInput";
import { DropDownFormat } from "../FormOptions/DropDownFormat";

export const JoinTaab30Form = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [educationList, seteducationList] = useState([]);
  const [checkLogin, setCheckLogin] = useState(null);
  const [tempbd, setTempbd] = useState(``);
  const [selectedEdu, setSelectedEdu] = useState(null);

  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.EduId,
      label: item.EduTitle,
    }));
  };

  const defaultValues = {
    field: "",
    name: "",
    sex: "",
    bd: "",
    edu: "",
    email: "",
    know: "",
    address: "",
    mob: "",
    description: "",
    attach: "",
  };

  const {
    handleSubmit,
    control,
    setValue,
    register,
    formState: { errors },
    reset,
  } = useForm({});

  useEffect(() => {
    if (checkLogin === "0") {
      dispatch(logoutStatic());
      navigate("/");
    }
  }, [checkLogin]);

  const onSubmit = async (data) => {
    let birthdate;

    birthdate = tempbd;
    console.log(data?.attach);
    const bodyFormData = new FormData();
    bodyFormData.append("field", data?.field);
    bodyFormData.append("name", data?.name);
    bodyFormData.append("sex", data?.sex.toString());
    bodyFormData.append("bd", birthdate);
    bodyFormData.append("edu", selectedEdu);
    bodyFormData.append("email", data?.email);
    bodyFormData.append("know", data?.know);
    bodyFormData.append("address", data?.address);
    bodyFormData.append("mob", data?.mob);
    bodyFormData.append("description", data?.description);
    bodyFormData.append("attach", data?.attach);

    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "joinus",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        setCheckLogin(data?.UserId);
        reset();
        SweetAlert({
          title: "Success",
          text: "درخواست شما با موفقیت ارسال شد.",
          type: "success",
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  useEffect(() => {
    fetchData("edu", {}, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    const formattedOptions = mapOptions(data?.dt);
    seteducationList(formattedOptions);
  };

  return (
    <div dir="rtl" className="p-4">
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col className="col-12 col-lg-4">
            <InputFormat
              control={control}
              name="field"
              type={"text"}
              label="زمینه فعالیت"
              errors={errors}
            />
          </Col>{" "}
          <Col className="col-12 col-lg-4">
            <InputFormat
              control={control}
              name="name"
              type={"text"}
              label="نام و نام خانوادگی"
              errors={errors}
            />
          </Col>
          <Col className=" col-12 col-lg-4">
            <Form.Label>جنسیت </Form.Label>
            <Form.Select
              className="w-75"
              aria-label="Default select example"
              {...register("sex", {
                required: "جنسیت الزامی است",
              })}
            >
              <option value="" disabled>
                انتخاب کنید...
              </option>
              <option value="1">مرد</option>
              <option value="2">زن</option>
            </Form.Select>
            {errors.sex && (
              <div className="text-danger">{errors.sex.message}</div>
            )}
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-4">
            <Form.Label>تاریخ تولد</Form.Label>
            <Controller
              control={control}
              className="txt-center w-75"
              name="bd"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
                formState: { errors },
              }) => (
                <>
                  <DatePicker
                    className="txt-center w-75"
                    value={""}
                    onChange={(date) => {
                      setTempbd(JSON.stringify(date?.toDate?.()));
                      onChange({ target: { name, value: date?.toDate?.() } });
                    }}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    defaultValue={"1996-12-02T12:01:39.860Z"}
                  />
                  {errors.BirhDay && <span>تاریخ تولد الزامی است</span>}
                </>
              )}
            />
          </Col>
          <Col className=" col-12 col-lg-4">
            <TelInput
              control={control}
              name="mob"
              type={"tel"}
              defaultValue={""}
              maxLength={"11"}
              label="شماره موبایل"
              errors={errors}
            />
          </Col>
          <Col className="col-12 col-lg-4">
            <DropDownFormat
              control={control}
              label={"تحصیلات"}
              options={educationList}
              errors={errors}
              name={"edu"}
            />
          </Col>
        </Row>
        <Row>
          <Col className=" col-12 col-lg-4">
            <InputFormat
              control={control}
              name="email"
              type={"text"}
              label="ایمیل"
              errors={errors}
            />
          </Col>
          <Col className="col-12 col-lg-4">
            <InputFormat
              control={control}
              name="know"
              type={"text"}
              label="آشنایی با تاب 30"
              errors={errors}
            />
          </Col>{" "}
          <Col className="col-12 col-lg-4">
            <InputFormat
              control={control}
              name="description"
              type={"text"}
              label="توضیحات"
              errors={errors}
            />
          </Col>
          <Col className="col-12 col-lg-10">
            <InputFormat
              control={control}
              name="address"
              type={"textarea"}
              label="آدرس"
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col className="col-6">
            <Form.Group className="mb-3 " controlId="formBasicPassword">
              <Form.Label> پیوست رزومه</Form.Label>
              <Controller
                name="attach"
                control={control}
                render={({ field }) => (
                  <input
                    type="file"
                    onChange={(e) => field.onChange(e.target.files[0])}
                  />
                )}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col className="col-12 col-lg-12 " dir="ltr">
            <Button variant="primary" type="submit">
              ذخیره
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
